import { render, staticRenderFns } from "./relatedTable.vue?vue&type=template&id=fb6cb49c&scoped=true&"
import script from "./relatedTable.vue?vue&type=script&lang=js&"
export * from "./relatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6cb49c",
  null
  
)

export default component.exports